import { render, staticRenderFns } from "./ComoConheceu.vue?vue&type=template&id=40be19c3"
import script from "./ComoConheceu.vue?vue&type=script&lang=js"
export * from "./ComoConheceu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports